import formatDuration from 'date-fns/formatDuration'
import intervalToDuration from 'date-fns/intervalToDuration'
import addSeconds from 'date-fns/addSeconds'

/**
 * Takes a duration in seconds and outputs a string of how many hrs days and mins it is
 * @param {number} seconds -
 * @param {boolean} toMinutesOnly -
 */
const _formatDuration = (seconds: number, toMinutesOnly?: boolean) => {

  const now = new Date(0)
  const interval = intervalToDuration({
    start: now,
    end: addSeconds(now, seconds)
  })

  const { days } = interval || {}

  if (toMinutesOnly && seconds >= 60 && !days) {

    try {

      const mins = Math.floor(seconds / 60)

      return `${mins} ${mins === 1 ? 'min' : 'mins'}`

    }
    // eslint-disable-next-line no-empty
    catch (e) { }

  }

  return formatDuration(interval, {
    format: ['days', 'hours', 'minutes', 'seconds']
  }).replace('second', 'sec')
    .replace('hour', 'hr')
    .replace('minute', 'min')

}

export default _formatDuration
